export default __webpack_public_path__ + "static/media/map-location.8c41fcd3.svg";